(function () {
  'use strict';

  function formatZAR(cents) {
    var rands = Math.round(cents) / 100;
    try {
      return new Intl.NumberFormat('en-ZA', {
        style: 'currency',
        currency: 'ZAR',
        maximumFractionDigits: 0,
        minimumFractionDigits: 0
      }).format(rands);
    } catch (e) {
      return 'R' + Math.round(rands).toLocaleString('en-ZA');
    }
  }

  class QuantityBreaks extends HTMLElement {
    connectedCallback() {
      this.unit = parseInt(this.dataset.unitPrice || '0', 10);
      this.compare = parseInt(this.dataset.compareAt || '0', 10);
      this.saveUnit = parseInt(this.dataset.saveUnit || '0', 10);
      this.formId = this.dataset.formId || '';
      this.options = Array.from(this.querySelectorAll('[data-qb-option]'));
      this.qtyLabel = this.querySelector('[data-qb-qty-label]');
      this.totalEl = this.querySelector('[data-qb-total]');
      this.saveEl = this.querySelector('[data-qb-save]');

      this.options.forEach((opt) => {
        opt.addEventListener('click', () => this.select(opt));
        const radio = opt.querySelector('[data-qb-radio]');
        if (radio) radio.addEventListener('change', () => this.select(opt));
      });

      const selected = this.querySelector('.qb__option.is-selected') || this.options[1] || this.options[0];
      if (selected) this.select(selected, true);

      document.addEventListener('londa:qb-sync', (e) => {
        if (e.detail && e.detail.source === this) return;
        if (e.detail && e.detail.qty) {
          const match = this.options.find((o) => String(o.dataset.qty) === String(e.detail.qty));
          if (match) this.select(match, true, true);
        }
      });
    }

    select(opt, silent, fromSync) {
      const qty = parseInt(opt.dataset.qty || '1', 10);
      this.options.forEach((o) => {
        const on = o === opt;
        o.classList.toggle('is-selected', on);
        const radio = o.querySelector('[data-qb-radio]');
        if (radio) radio.checked = on;
      });

      const total = this.unit * qty;
      const save = this.saveUnit * qty;
      if (this.qtyLabel) this.qtyLabel.textContent = 'Buy ' + qty;
      if (this.totalEl) this.totalEl.textContent = formatZAR(total);
      if (this.saveEl) {
        this.saveEl.textContent = save > 0 ? 'You save ' + formatZAR(save) : '';
      }

      this.syncQuantityInputs(qty);
      this.syncAtcLabels(qty, total, save);
      this.syncSticky(qty, total, save);

      if (!fromSync) {
        document.dispatchEvent(
          new CustomEvent('londa:qb-sync', { detail: { qty: qty, source: this } })
        );
      }
      if (!silent) {
        document.dispatchEvent(
          new CustomEvent('londa:qb-change', { detail: { qty: qty, total: total, save: save } })
        );
      }
    }

    syncQuantityInputs(qty) {
      const forms = [];
      if (this.formId) {
        const f = document.getElementById(this.formId);
        if (f) forms.push(f);
      }
      document.querySelectorAll('form[data-product-form], form.product-form').forEach((f) => {
        if (!forms.includes(f)) forms.push(f);
      });
      forms.forEach((form) => {
        const input = form.querySelector('input[name="quantity"]');
        if (input) {
          input.value = String(qty);
          input.dispatchEvent(new Event('change', { bubbles: true }));
        }
      });
    }

    syncAtcLabels(qty, total, save) {
      const label =
        save > 0
          ? 'Add Buy ' + qty + ' to cart — save ' + formatZAR(save)
          : 'Add Buy ' + qty + ' to cart';
      document.querySelectorAll('[data-qb-atc], product-form [type="submit"][name="add"], #HeroBuy [type="submit"]').forEach((btn) => {
        if (btn.disabled) return;
        btn.textContent = label;
        btn.dataset.qbQty = String(qty);
      });
    }

    syncSticky(qty, total, save) {
      const stickyPrice = document.querySelector('[data-sticky-price]');
      const stickyBtn = document.querySelector('[data-sticky-submit]');
      if (stickyPrice) stickyPrice.textContent = 'Buy ' + qty + ' · ' + formatZAR(total);
      if (stickyBtn && !stickyBtn.disabled) {
        stickyBtn.textContent =
          save > 0 ? 'Add Buy ' + qty + ' · save ' + formatZAR(save) : 'Add Buy ' + qty;
      }
    }
  }

  if (!customElements.get('quantity-breaks')) {
    customElements.define('quantity-breaks', QuantityBreaks);
  }
})();
